import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button} from '@material-ui/core';
import { BUDGET_SUBSCRIBERS_MODULE, SUBSCRIPTION_NOTES, SUBSCRIPTION_OPTIONS } from '../../constants/commons'


class BudgetSubscribersTabComponent extends React.Component {
  static propTypes = {
    screenWidth: PropTypes.number,
    selectedSubscriptionType: PropTypes.string,
    setSelectedSubscription: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = {
      selectedSubscriptionType: BUDGET_SUBSCRIBERS_MODULE
    }
  }

  selectedSubscription = (subscriptionType) => {
    this.setState({ selectedSubscriptionType: subscriptionType })
    this.props.setSelectedSubscription(subscriptionType)
  }

  render () {
    return (
      <Box className="d-flex flex-wrap flexGap" id='budgetSubscribersTabs'>
        <Button variant="contained" className={'labelBtn ' + (this.state.selectedSubscriptionType === BUDGET_SUBSCRIBERS_MODULE ? 'budgetsActive' : '')} onClick={() => this.selectedSubscription(BUDGET_SUBSCRIBERS_MODULE)}>{BUDGET_SUBSCRIBERS_MODULE}</Button>
        <Button variant="contained" className={'labelBtn ' + (this.state.selectedSubscriptionType === SUBSCRIPTION_OPTIONS ? 'subscriptionActive' : '')} onClick={() => this.selectedSubscription(SUBSCRIPTION_OPTIONS)}>{SUBSCRIPTION_OPTIONS}</Button>
        <Button variant="contained" className={'labelBtn ' + (this.state.selectedSubscriptionType === SUBSCRIPTION_NOTES ? 'notesActive' : '')} onClick={() => this.selectedSubscription(SUBSCRIPTION_NOTES)}>{SUBSCRIPTION_NOTES}</Button>
      </Box>
    )
  }
}

export default BudgetSubscribersTabComponent
